import React, { Component } from 'react';
import { Span, Span2, Div, H1, P, ImgUploder, Rating, Opts } from './elemans/_elemans'
import { consts, icons } from '../services/_consts';
import CvMakerContext from '../services/app-context';

export class Template4 extends Component {
    static contextType = CvMakerContext;
    constructor(props) {
        super(props);
        this.state = props.cv;
        this.sideCdd = 'col-3 text-end';
    }
    defaultColor = '#525252';
    style = {
        las: {
            // background: 'gray',
            // padding: '3px',
            borderRadius: '5px',
            // color: 'white',
            margin: '0 4px',
            fontSize: '24px'
        }
    }

    componentDidMount() {
        if (this.state.color2 == "#ffff00") {
            this.setState({ color2: this.defaultColor });
        }
    }


    remove = (field, i) => this.props.onRemoveFromList(field, i);

    up = (field, i) => this.props.onMoveInList(field, i, 'up');

    down = (field, i) => this.props.onMoveInList(field, i, 'down');


    render() {
        return (<>
            <div className='row ' >
                <div className='col px-4 pt-5'>

                    <div className="row mb-2 text-center">
                        {this.state.showAvatar && <div className="col-5 text-end">

                            <ImgUploder avatar={this.state.avatar}
                                maxSize="160000"
                                onChanged={f => {
                                    if (!this.props.readonly) {
                                        this.setState({ avatar: f });
                                        this.props.handleChange('avatar', f);
                                    }
                                }}
                                style={{ width: '70px', height: '70px', borderRadius: '0', border: `0px solid ${this.state.color2}44` , filter: 'grayscale(1)' }}
                            />
                        </div>}
                        <div className={(this.state.showAvatar ? "col-7 text-start" : "col text-center")}>
                            <H1 onBlur={e => this.props.onContentChanged(e, 'fullName')} >{this.state.fullName}</H1>
                            {this.state.showMySmallDesc && < Div onBlur={e => this.props.onContentChanged(e, 'mySmallDesc')}>{this.state.mySmallDesc}</Div>}
                        </div>
                    </div>
                    <div className="row text-start">
                        <div className='col pt-2 border-top border-bottom border-1 border-secondary' style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)' }}>

                            <Span2 style={{ color: this.state.color2 }} showCondition={this.state.showBirthDate} icon={icons.birthDate}
                                onBlur={e => this.props.onContentChanged(e, 'birthDate')} >
                                {this.state.birthDate}
                            </Span2>


                            <Span2 style={{ color: this.state.color2 }} icon={icons.phone}
                                onBlur={e => this.props.onContentChanged(e, 'tel')} >
                                {this.state.tel}
                            </Span2>

                            <Span2 style={{ color: this.state.color2 }} icon={icons.mapMarker}
                                onBlur={e => this.props.onContentChanged(e, 'address')} >
                                {this.state.address}
                            </Span2>

                            <Span2 style={{ color: this.state.color2 }} icon={icons.at}
                                onBlur={e => this.props.onContentChanged(e, 'email')}
                                onRemove={() => this.remove('email')} >
                                {this.state.email}
                            </Span2>

                            <Span2 showCondition={this.state.showSite} style={{ color: this.state.color2 }} icon={icons.link}
                                onBlur={e => this.props.onContentChanged(e, 'site')}
                                onRemove={() => this.remove('showSite')} >
                                {this.state.site}
                            </Span2>

                            <Span2 showCondition={this.state.showGithub} style={{ color: this.state.color2 }} icon={icons.github}
                                onBlur={e => this.props.onContentChanged(e, 'github')}
                                onRemove={() => this.remove('showGithub')} >
                                {this.state.github}
                            </Span2>

                            <Span2 showCondition={this.state.showLinkedIn} style={{ color: this.state.color2 }} icon={icons.linkdIn}
                                onBlur={e => this.props.onContentChanged(e, 'linkeIn')}
                                onRemove={() => this.remove('showLinkedIn')} >
                                {this.state.linkeIn}
                            </Span2>

                            <Span2 showCondition={this.state.showMarriage} style={{ color: this.state.color2 }} icon={icons.marriage}
                                onBlur={e => this.props.onContentChanged(e, 'marriage')}
                                onRemove={() => this.remove('showMarriage')} >
                                {this.state.marriage}
                            </Span2>

                            <Span2 showCondition={this.state.showMilitaryService} style={{ color: this.state.color2 }} icon={icons.militaryService}
                                onBlur={e => this.props.onContentChanged(e, 'militaryService')}
                                onRemove={() => this.remove('showMilitaryService')} >
                                {this.state.militaryService}
                            </Span2>

                        </div>
                    </div>

                    {this.state.showSummery &&
                        <div className='row Summery mt-2 px-4 border-bottom border-1 border-secondary'>
                            <p contenteditable="true" onBlur={e => this.props.onContentChanged(e, 'summery')} >{this.state.summery}</p>
                        </div>
                    }


                </div>
            </div >
            <div className='row m-0 '>
                <div className='col px-0 pb-5 pt-0'>
                    {this.state.educations.length > 0 &&
                        <div className='Educations border-bottom border-1 border-secondary'>
                            <div className='row'>
                                <div className={this.sideCdd}>
                                    <div className='mt-3 Educations'>
                                        <div className=''>
                                            <Span onBlur={e => this.props.onContentChanged(e, 'titleEducations')} className='h6  ' >{this.state.titleEducations}</Span>
                                            <button onClick={() => { this.setState({ educations: [...this.state.educations, {}] }) }} className="add-btn noPrint">{consts.add}</button>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-9 border-start border-1 border-secondary'>
                                    <ul className="" >
                                        {this.state.educations.map((x, i) =>
                                            <li key={i} className="pt-2" id={`educations${i}`} >
                                                <span onBlur={e => this.props.onContentEditedInList(e, 'educations', i, 'level')} className='text-gray pe-4' contenteditable="true">{x.level}</span>
                                                <span onBlur={e => this.props.onContentEditedInList(e, 'educations', i, 'year')} contenteditable="true">{x.year}</span> -
                                                <span onBlur={e => this.props.onContentEditedInList(e, 'educations', i, 'university')} contenteditable="true">{x.university}</span> –
                                                <span onBlur={e => this.props.onContentEditedInList(e, 'educations', i, 'city')} contenteditable="true">{x.city}</span> –
                                                <span onBlur={e => this.props.onContentEditedInList(e, 'educations', i, 'field')} contenteditable="true">{x.field}</span>
                                                {this.props.readonly ||
                                                    <Opts i={i} length={this.state.educations.length}
                                                        onUp={() => this.up('educations', i)}
                                                        onDown={() => this.down('educations', i)}
                                                        onRemove={() => this.remove('educations', i)}
                                                    />}                                                    </li>)}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    }

                    <div className='Skills border-bottom border-1 border-secondary'>
                        <div className='row'>
                            <div className={this.sideCdd}>
                                <div className=''>
                                    <Span onBlur={e => this.props.onContentChanged(e, 'titleSkills')} className='h6  ' >{this.state.titleSkills}</Span>
                                    <button onClick={() => { this.setState({ skills: [...this.state.skills, {}] }) }} className="add-btn noPrint">{consts.add}</button>
                                </div>
                            </div>
                            <div className='col-9 border-start border-1 border-secondary'>
                                <ul className="" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)' }}>
                                    {this.state.skills.map((x, i) =>
                                        <li style={{ margin: '2px' }} key={i} id={`skills${i}`} >
                                            <Rating
                                                rateOf10={x.rateOf10}
                                                showRating={this.state.showSkillRating}
                                                onBlur={e => this.props.onContentEditedInList(e, 'skills', i, 'title')}
                                                ocRatechange={(e, r) => this.props.onRatechange(e, 'skills', i, r)}
                                                retedcolor={this.state.color2}
                                                notRatedColor='#b5b3b3'
                                            >{x.title}</Rating>
                                            {this.props.readonly ||
                                                <Opts i={i} length={this.state.skills.length} type="leftRight"
                                                    onUp={() => this.up('skills', i)}
                                                    onDown={() => this.down('skills', i)}
                                                    onRemove={() => this.remove('skills', i)}
                                                />}                                                </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>

                    {this.state.workExperinces.length > 0 &&
                        <div className='WorkExperince border-bottom border-1 border-secondary'>
                            <div className='row'>
                                <div className={this.sideCdd}>
                                    <div className=''>
                                        <Span onBlur={e => this.props.onContentChanged(e, 'titleWorkExperince')} className='h6  ' >{this.state.titleWorkExperince}</Span>
                                        <button onClick={() => { this.setState({ workExperinces: [...this.state.workExperinces, {}] }) }} className="add-btn noPrint">{consts.add}</button>
                                    </div>
                                </div>
                                <div className='col-9 border-start border-1 border-secondary pe-3'>
                                    <ul className="">
                                        {this.state.workExperinces.map((x, i) =>
                                            <li key={i} id={`workExperinces${i}`} >
                                                <span onBlur={e => this.props.onContentEditedInList(e, 'workExperinces', i, 'name')} className='text-gray me-3' contenteditable="true">{x.name}</span>

                                                <div className='text-gray me-3 float-end'>
                                                    <Span onBlur={e => this.props.onContentEditedInList(e, 'workExperinces', i, 'from')} className='text-gray'>{x.from}</Span> -
                                                    <Span onBlur={e => this.props.onContentEditedInList(e, 'workExperinces', i, 'until')} className='text-gray'>{x.until}</Span>
                                                </div>

                                                {this.props.readonly ||
                                                    <Opts i={i} length={this.state.workExperinces.length}
                                                        onUp={() => this.up('workExperinces', i)}
                                                        onDown={() => this.down('workExperinces', i)}
                                                        onRemove={() => this.remove('workExperinces', i)}
                                                    />}                                                        <div className='ms-4'>
                                                    <span onBlur={e => this.props.onContentEditedInList(e, 'workExperinces', i, 'title')} contenteditable="true" style={{ fontWeight: 'bold' }}>{x.title}</span>
                                                    <div onBlur={e => this.props.onContentEditedInList(e, 'workExperinces', i, 'desc')} contenteditable="true">{x.desc}</div>
                                                </div>
                                            </li>)}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    }

                    {this.state.freelanceProjects.length > 0 &&
                        <div className='FreelanceProject border-bottom border-1 border-secondary'>
                            <div className='row'>
                                <div className={this.sideCdd}>
                                    <div className=''>
                                        <Span onBlur={e => this.props.onContentChanged(e, 'titleFreelanceProjects')} className='h6  ' >{this.state.titleFreelanceProjects}</Span>
                                        <button onClick={() => { this.setState({ freelanceProjects: [...this.state.freelanceProjects, {}] }) }} className="add-btn noPrint">{consts.add}</button>
                                    </div>
                                </div>
                                <div className='col-9 border-start border-1 border-secondary pe-3'>
                                    <ul className="">
                                        {this.state.freelanceProjects.map((x, i) =>
                                            <li key={i} id={`freelanceProjects${i}`} >
                                                <span onBlur={e => this.props.onContentEditedInList(e, 'freelanceProjects', i, 'name')} className='text-gray me-3' contenteditable="true">{x.name}</span>
                                                {this.props.readonly ||
                                                    <Opts i={i} length={this.state.freelanceProjects.length}
                                                        onUp={() => this.up('freelanceProjects', i)}
                                                        onDown={() => this.down('freelanceProjects', i)}
                                                        onRemove={() => this.remove('freelanceProjects', i)}
                                                    />}                                                         <div className='ms-4'>
                                                    <div onBlur={e => this.props.onContentEditedInList(e, 'freelanceProjects', i, 'desc')} contenteditable="true">{x.desc}</div>
                                                </div>
                                            </li>)}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    }

                    {this.state.languages.length > 0 &&
                        <div className='Languages border-bottom border-1 border-secondary'>
                            <div className='row'>
                                <div className={this.sideCdd}>
                                    <div className=''>
                                        <Span onBlur={e => this.props.onContentChanged(e, 'titleLanguages')} className='h6  ' >{this.state.titleLanguages}</Span>
                                        <button onClick={() => { this.setState({ languages: [...this.state.languages, {}] }) }} className="add-btn noPrint">{consts.add}</button>

                                    </div>
                                </div>
                                <div className='col-9 border-start border-1 border-secondary'>
                                    <ul className="" style={{ columns: '2' }}>
                                        {this.state.languages.map((x, i) =>
                                            <li style={{ margin: '2px' }} key={i} id={`languages${i}`} >
                                                <Rating
                                                    rateOf10={x.rateOf10}
                                                    showRating={this.state.showLanguageRatting}
                                                    maxValue='5'
                                                    onBlur={e => this.props.onContentEditedInList(e, 'languages', i, 'title')}
                                                    ocRatechange={(e, r) => this.props.onRatechange(e, 'languages', i, r)}
                                                    retedcolor={this.state.color2}
                                                >{x.title}</Rating>
                                                {this.props.readonly ||
                                                    <Opts i={i} length={this.state.languages.length} type="leftRight"
                                                        onUp={() => this.up('languages', i)}
                                                        onDown={() => this.down('languages', i)}
                                                        onRemove={() => this.remove('languages', i)}
                                                    />}                                                    </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    }

                    {this.state.certificates.length > 0 &&
                        <div className='Certificates border-bottom border-1 border-secondary'>
                            <div className='row'>
                                <div className={this.sideCdd}>
                                    <div className=''>
                                        <Span onBlur={e => this.props.onContentChanged(e, 'titleCertificates')} className='h6  ' >{this.state.titleCertificates}</Span>
                                        <button onClick={() => { this.setState({ certificates: [...this.state.certificates, {}] }) }} className="add-btn noPrint">{consts.add}</button>
                                    </div>
                                </div>
                                <div className='col-9 border-start border-1 border-secondary pe-3'>
                                    <ul className="" >
                                        {this.state.certificates.map((x, i) =>
                                            <li key={i} id={`certificates${i}`}>
                                                <Span onBlur={e => this.props.onContentEditedInList(e, 'certificates', i, 'title')} className='text-gray me-3'><i className="las la-certificate" style={this.style.las}></i>{x.title}</Span>
                                                <Span onBlur={e => this.props.onContentEditedInList(e, 'certificates', i, 'date')} className='text-gray me-3 float-end'>{x.date}</Span>
                                                {this.props.readonly ||
                                                    <Opts i={i} length={this.state.certificates.length}
                                                        onUp={() => this.up('certificates', i)}
                                                        onDown={() => this.down('certificates', i)}
                                                        onRemove={() => this.remove('certificates', i)}
                                                    />}                                                        <div className='ms-4'>
                                                    <Div onBlur={e => this.props.onContentEditedInList(e, 'certificates', i, 'desc')} >{x.desc}</Div>
                                                </div>
                                            </li>)}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    }

                </div>
            </div>
        </>);
    }
}
